

const schoolInfo = {
	the: "the",
	totalman: "totalman",
	school: "schools",
	address: "11 Ojamakinwa takuro street, addo, ajah, lagos",
	mobile: "08138814725",
	email: "thetotalmancollege@gmail.com",
}

export { schoolInfo }